export * from './register.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/register/index.ts